<template>
	<div class="container">
		<div class="list-title">Download Adorime APP</div>
		<!-- <div class="list-sub-title">[Secret Lover Lite]</div> -->
		<div class="section">
			<div class="platform-container" @click="iosClick()">
				<img class="platform-logo" src="@/assets/ios_btn.png"/>
			</div> 
<!-- 			<div class="platform-container" @click="androidPureClick()">
				<img class="platform-logo" src="@/assets/app_pure.png"/>
			</div>
			<div class="platform-container" @click="androidWebClick()">
				<img class="platform-logo" src="@/assets/android_web.png"/>
			</div> -->
			<div class="platform-container" @click="androidGoogleClick()">
				<img class="platform-logo" src="@/assets/android_google.png"/>
			</div>
		</div>
		
		<div class="about-title">About Adorime APP</div>
		<div class="discription">Expand the functions gameplay of your toys by connecting to Adorime APP</div>
		
	</div>
</template>


<script>
	
import Vue from 'vue'
import wx from 'weixin-js-sdk'
// var wx = require('weixin-js-sdk');

export default {
  name: 'app',
  components: {
  },
  data(){
	  return{
	  }
  },
  
  computed:{
	  richTitle1(){
		  var str="1.Search for “Secrect Love” in App store, download and install.Or Download link: <a href='https://www.pgyer.com/secret_love_ios'>ios dizhi</a>";
		  return str;
	  },
	  
	  richTitle2(){
		  var str="2.Search for “Secrect Love” in Google Play, download and install.Or Download link: <a href='https://www.pgyer.com/sercret_love_android'>https://www.pgyer.com/sercret_love_android</a>";
		  return str;
	  },
  },
  
 
  mounted() {
  },
  
  
  beforeDestroy() {
  },
  
  created() {
		window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  
  destroyed() {
		window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  
 
  methods:{
		beforeunloadFn(e) {
			console.log('刷新或关闭')
		}, 
		
	  //搜索高亮
		brightenKeyword(val, keyword) {
		  if (keyword.length > 0) {
			val = val + "";
			var item = keyword;
			if (val.indexOf(item) !== -1 && item !== "") {
				val = val.replace(
				  new RegExp(item,'g'),
				  '<font color="#ff0000">' + item + "</font>"
				);
			  }
			return val;
		  } else {
			return val;
		  }
		},
		

		okButtonClick(e){
			var infoString = "";
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
			if (isAndroid) {
				window.Android.okButtonClick(infoString);
			} else if (isiOS) {
				window.webkit.messageHandlers.okButtonClick.postMessage(infoString) //url为分享的链接地址
			}
		},
		
		refuseButtonClick(e){
			var infoString = "";
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
			if (isAndroid) {
				window.Android.refuseButtonClick(infoString);
			} else if (isiOS) {
				window.webkit.messageHandlers.refuseButtonClick.postMessage(infoString) //url为分享的链接地址
			}
		},
		
		
		iosClick() {
		   location.href="https://itunes.apple.com/app/id6472883959"
		   // location.href="https://testflight.apple.com/join/5noIOzYn";
		},
		
		androidWebClick() {
			///http://play.google.com/store/apps/details?id=com.sina.weibo
		   // location.href="http://app.hudouchat.com/adorimeApp"
		   var time = new Date().getTime();
		   location.href = "https://d9tl7kdnsczcu.cloudfront.net/app-resource/apk/adorime_release.apk?time="+time;
		   // location.href="http://hey.scandown.com/z2e3"
		   // location.href="http://a.app.qq.com/o/simple.jsp?pkgname=com.wensheng.rejoapplication";
		},
		
		androidPureClick(){
			location.href = "https://apkpure.com/adorime/com.zhuole.adorime/downloading";
		},
		
		androidGoogleClick() {
			///http://play.google.com/store/apps/details?id=com.sina.weibo
			location.href="https://play.google.com/store/apps/details?id=com.zhuole.adorimeclub&referrer=utm_source%3Dgoogle-link-102%26utm_medium%3Dlink%26utm_term%3DlinkTerm%26utm_content%3Dlink";
		   // location.href="https://www.pgyer.com/inN9YO"
		},

	}

}
</script>

<style>
	#app {
	/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	  margin-top: 60px; */
	  padding: 0;
	  margin: 0;
	}

	.container{
		padding: 0;
		margin: 0;
		height: 100vh;
		width: 100vw;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		background: linear-gradient(to bottom, #37A9FB, #ED47FF);
	}
	
	.list-title{
		font-weight: bolder;
		font-size: 24px;
		color: white;
		margin-top: 60px;
	}
	
	.list-sub-title{
		font-size: 16px;
		color: white;
		margin-top: 10px;
	}
	
	.section{
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-top: 60px;
	}
	
	.platform-container{
		margin-left: 50px;
		margin-top: 30px;
		width: calc(100vw - 100px);
		height: calc((100vw - 100px)*0.2544);
	}
	
	.platform-logo{
		width: 100%;
		height: 100%;
	}
	
	.about-title{
		font-size: 16px;
		color: white;
		margin-top: 60px;
	}

	.discription{
		font-size: 14px;
		color: white;
		margin-top: 10px;
		margin-left: 15px;
		width: calc(100vw - 30px);
		text-align: center;
	}

</style>
